import React, { Component } from 'react'
import intl from 'react-intl-universal'
import Page from './Page'

class NotFoundRoute extends Component {
  render () {
    return (
      <Page title='Page not found'>
        <article className='b-info'>
          <h2 className='b-info-title'>404</h2>
          <h3 className='b-info-subtitle'>{intl.get('Page not found')}</h3>
        </article>
      </Page>
    )
  }
}

export default NotFoundRoute



// WEBPACK FOOTER //
// ./src/containers/NotFoundRoute.js